import axios from "axios"
import { useUserStore } from "@/store/user"

const instance = axios.create({
  baseURL: process.env.VUE_APP_API_BASE_URL
})

instance.interceptors.request.use((config) => {
  const userStore = useUserStore()
  
  const token = userStore.token

  if (userStore.token) {
    config.headers = { ...(config.headers || {}), Authorization: `Bearer ${token}` }
  }

  return config
})

export default instance
